// lib/supabase.ts
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://gepfqtzxtvdfcdcjgikh.supabase.co'
const supabaseAnonKey = 'sb_publishable_IpVava_ql4zi9PYa97JCUw_NGVbaEwm'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)